import React, { useState, useEffect, useCallback, useRef } from "react";
import { ToastContainer } from "react-toastify";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import { productRequestOrder } from "services/utils/companyAccess";
import {
  pathAndProducts,
  supportLabel,
  adminRoleName,
} from "./services/constants/index";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/organflow-dashboard.scss?v1.2.1";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { getAccessBasedRoute } from "services/utils/accessedBasedRoute";
import { loadLoginAccess, storeLoginAccess } from "services/utils/loginAccess";
import { initializeRouteAccess } from "services/utils/initialRouteAccess";
import {
  stripLoginParams,
  watchCrossTabLogout,
} from "services/utils/sessionLifecycle";
import {
  setReloadApi,
  setReloadHRMSApi,
  setAllStatus,
  setActiveStatus,
  setLeaveStatus,
  setOnBreakStatus,
} from "services/Redux/leaveManagement";
import {
  setCurrentUser,
  setToken,
  setProductAccess,
  setTopbarCompanyId,
  setTopbarCompanyName,
  setVisible,
  setCompanyList,
  setCompanyDetails,
} from "./services/Redux/userToken";
import {
  setCurrentScreen,
  setSubMenuExpand,
  setShowDeploymentMessage,
} from "services/Redux/userManagament";
import { toastContainerStyle } from "./services/constants/index";
import { getToken, onMessage } from "firebase/messaging";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getRoutesByRole } from "routes";
import "App.css";
import { messaging } from "./firebase";
import FrajunWidget from "components/FrajunWidget";
import IncomingCallNotification from "components/contacts/IncomingCallNotification";
import { Loader } from "components/Loader";
import { ContactDrawerProvider } from "components/contacts/GlobalContactDrawer";

let currentUserDetails = {};

export default function App() {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const location = useLocation();
  const isCrmRoute = location.pathname.startsWith("/crm");
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const bootstrapSession = useRef(null);
  const urlParams = new URLSearchParams(window.location.search);
  const tokenDetails = urlParams.get("token");
  const userEmail = urlParams.get("email");
  const userPhoneNumber = urlParams.get("ph_no");
  let user_token = useSelector((state) => state.tokenReducer.token);
  let [redirect, setRedirect] = useState("");
  let [authenticated, setAuthenticated] = useState(false);
  const [deploying, setDeploying] = useState(false);
  const domainUrl = useSelector((state) => state.tokenReducer.domain);
  const token = useSelector((state) => state.tokenReducer.token);
  const productAccess = useSelector(
    (state) => state.tokenReducer.productAccess,
  );
  // console.log("Redux visible changed:", visible);
  const date = new Date().toISOString().split("T")[0];
  const routes = getRoutesByRole(
    JSON.parse(localStorage.getItem("productAccess"))
      ? JSON.parse(localStorage.getItem("productAccess"))
      : null,
  );
  if (tokenDetails) {
  }

  const updateUserToken = useCallback(
    async (userToken, userId) => {
      try {
        function getCSRFToken() {
          return document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1];
        }

        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname.startsWith("127.");

        let response;

        if (!isLocalhost) {
          await fetch(`${domainUrl}csrf/`, { credentials: "include" });

          response = await fetch(`${domainUrl}fcm_token/`, {
            method: "PUT",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": getCSRFToken(),
            },
            body: JSON.stringify({ fcm_token: userToken, user_id: userId }),
          });
        } else {
          response = await fetch(`${domainUrl}fcm_token/`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ fcm_token: userToken, user_id: userId }),
          });
        }

        if (!response.ok) {
          throw new Error("Failed to update the token on the server");
        }
      } catch (error) {}
    },
    [domainUrl],
  );

  React.useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.deploymentInProgress) {
          localStorage.setItem("deploymentInProgress", "true");
          setDeploying(true);
          localStorage.clear();
          localStorage.setItem("LoginTag", "Email");
          history.push("/auth/login");
          window.location.reload();
        }
      });
    }

    if (localStorage.getItem("deploymentInProgress") === "true") {
      setDeploying(true);
    }
  }, [history]);

  React.useEffect(() => watchCrossTabLogout(), []);

  React.useEffect(() => {
    const notifEnabled =
      localStorage.getItem("callNotificationEnabled") !== "false";
    if (
      notifEnabled &&
      "Notification" in window &&
      Notification.permission === "default"
    ) {
      Notification.requestPermission();
    }
  }, []);

  const callYourApiFunction = useCallback(async () => {
    if (!requestCompanyId) return;
    try {
      const response = await fetch(`${domainUrl}checkinfilter/?date=${date}&company_id=${requestCompanyId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      if (response.status === 409) {
        sessionHandling(token);
      }
      dispatch(setReloadApi(true));
      dispatch(setAllStatus(true));
      dispatch(setReloadHRMSApi(true));
      dispatch(setActiveStatus(true));
      dispatch(setLeaveStatus(true));
      dispatch(setOnBreakStatus(true));
      await response.json();
    } catch (error) {
      console.error("[App] operation failed:", error);
      showToast("error", "Could not load data. Please refresh the page.");
    }
  }, [date, dispatch, domainUrl, token, requestCompanyId]);

  const updateCompanyDetails = useCallback(
    async (token, userId, domainUrl, userType) => {
      const request = productRequestOrder.start();
      const access = await loadLoginAccess({
        domain: domainUrl,
        token,
        userId,
        userType,
        preferredId: localStorage.getItem("topbarCompanyId"),
      });
      if (!productRequestOrder.isCurrent(request)) return;
      storeLoginAccess(access);
      dispatch(setCompanyList(access.companies));
      dispatch(setTopbarCompanyId(access.company?.company_id ?? null));
      dispatch(setTopbarCompanyName(access.company?.company_name ?? ""));
      dispatch(setProductAccess({
        products: access.products,
        company_id: access.company?.company_id ?? null,
      }));
    },
    [dispatch],
  );

  const getRouteNames = useCallback(
    async (user, redirectPath, redirectSearch = "", apiToken) => {
      const context = await initializeRouteAccess({
        routes,
        pathname: redirectPath,
        domain: domainUrl,
        token: apiToken,
        companyId: localStorage.getItem("topbarCompanyId"),
        userType: user?.type,
        companies: JSON.parse(localStorage.getItem("companyAccess") || "[]"),
        dispatch,
      });
      dispatch(setVisible(context?.productName === "CRM"));
      if (context) {
        localStorage.setItem("currentScreen", context.productName);
        localStorage.setItem("currentSubMenu", context.screenName);
        dispatch(setCurrentScreen(context.screenName));
        dispatch(setSubMenuExpand(true));
      }
      // Preserve a deep link's query string after initializing its product.
      setRedirect(redirectPath + redirectSearch);
    },
    [dispatch, domainUrl, routes],
  );

  const updateCurrentUserDetails = useCallback(
    async (currentUserString, api_token) => {
      const currentUserId = currentUserString
        ? String(currentUserString.id)
        : null;
      dispatch(setCurrentUser(currentUserString));
      const res = await customGetAPIWithToken(
        `${domainUrl}company/`,
        api_token,
      );
      if (res.ok) {
        let accessibleProducts = JSON.parse(
          localStorage.getItem("productAccess"),
        );

        let product_name = accessibleProducts
          ? accessibleProducts[0]?.product_name
          : "default";
        let redirectPath =
          res?.responseDetails?.length === 0 &&
          [adminRoleName, supportLabel].includes(currentUserString?.type)
            ? "Administration"
            : product_name;
        const accesbasedReroutePath = getAccessBasedRoute(redirectPath);
        let path_config =
          location.pathname === "/" || location.pathname === "/auth/login"
            ? accesbasedReroutePath
            : location.pathname;
        let redirect_path =
          accessibleProducts?.length === 0
            ? "/admin/edit/profile/"
            : path_config;
        if (location.pathname !== "/" && location.pathname !== "/auth/login") {
          const parts = redirect_path.split("/");
          const match = pathAndProducts.find(
            (item) => item.pathname === parts[2],
          );
          const isAccessible = accessibleProducts?.some(
            (product) => product.product_name === match?.productname,
          );
          redirect_path =
            isAccessible || redirect_path === "/admin/edit/profile/"
              ? redirect_path
              : accessibleProducts?.length > 0
                ? accesbasedReroutePath
                : "/admin/edit/profile/";
        }
        // Only reattach the query string when redirect_path still IS the
        // page actually loaded — not when one of the access checks above
        // swapped it for a different landing page (e.g. "/admin/edit/
        // profile/"), where the original ?view=... wouldn't apply.
        const redirectSearch =
          redirect_path === location.pathname ? stripLoginParams(location.search) : "";
        await getRouteNames(
          currentUserString,
          redirect_path,
          redirectSearch,
          api_token,
        );
        localStorage.setItem(
          "companyDetails",
          JSON.stringify(res?.responseDetails),
        );
        const companyResults = Array.isArray(res?.responseDetails)
          ? res.responseDetails
          : (res?.responseDetails?.results ?? []);
        dispatch(setCompanyDetails(companyResults));
      }
      setLoading(false);
      setAuthenticated(true);
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        showToast(
          "info",
          "Please allow notifications so we can keep you informed.",
        );
        return;
      }
      const existingUserId = localStorage.getItem("currentUserId");
      const existingToken = localStorage.getItem("fcmToken");
      if (permission === "granted") {
        navigator.serviceWorker.ready.then(async (registration) => {
          try {
            const token = await getToken(messaging, {
              serviceWorkerRegistration: registration,
            });
            if (token !== existingToken || currentUserId !== existingUserId) {
              await updateUserToken(token, currentUserId);
              localStorage.setItem("fcmToken", token);
              localStorage.setItem("currentUserId", currentUserId);
            }
          } catch (error) {
            console.error("[App] operation failed:", error);
          }

          window.addEventListener("focus", () => {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({ type: "PING" });
            }
          });
          navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data.deploymentInProgress) {
              localStorage.setItem("deploymentInProgress", true);
            }
          });
          const unsubscribe = onMessage(messaging, (payload) => {
            if (payload.data) {
              showToast(
                "success",
                payload.data?.body || payload.notification?.body,
              );
              if (
                payload.data.body ===
                "The deployment process is ongoing, so please wait for it to be completed"
              ) {
                localStorage.clear();
                localStorage.setItem("LoginTag", "Email");
                history.push("/auth/login");
                window.location.reload();
              }
              if (
                payload.notification?.body ===
                "A deployment will begin soon. Please save your work and refresh the application once the deployment is complete."
              ) {
                dispatch(setShowDeploymentMessage(true));
              }
            }
            if (payload.data && payload.data.triggerApi) {
              callYourApiFunction();
            }
          });

          return () => {
            unsubscribe();
          };
        });
      }
    },
    [
      callYourApiFunction,
      dispatch,
      domainUrl,
      getRouteNames,
      history,
      location.pathname,
      location.search,
      updateUserToken,
    ],
  );

  const getUserDetails = useCallback(async () => {
    if (userEmail || userPhoneNumber) {
      let url = userEmail
        ? `${domainUrl}login/email_verfication/?email=${userEmail}`
        : `${domainUrl}phone_verfication/?phone_no=${userPhoneNumber}`;
      let tenantUrl = userEmail
        ? `${domainUrl}user_tenant/details/?email=${userEmail}`
        : `${domainUrl}user_tenant/details/?phone_number=${userPhoneNumber}`;
      const emailResponse = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const emailReturnResponse = await emailResponse.json();
      if (emailResponse.status === 200) {
        const userData = {
          id: emailReturnResponse.user_id,
          first_name: emailReturnResponse.emailuser.first_name,
          username: emailReturnResponse.emailuser.username,
          last_name: emailReturnResponse.emailuser.last_name,
          email: emailReturnResponse.emailuser.email,
          type: emailReturnResponse.type,
          approver: emailReturnResponse.approver,
          teamlead: emailReturnResponse.teamlead,
          firmName: emailReturnResponse.firm_name,
          approver_id: emailReturnResponse.approver_id,
          image_url: emailReturnResponse.image_url,
          department_id: emailReturnResponse.department_id,
          department_name: emailReturnResponse.department_name,
          employee_id: emailReturnResponse.employee_id,
          designation: emailReturnResponse.designation,
        };
        currentUserDetails = userData;
        localStorage.setItem("currentuser", JSON.stringify(userData));
        localStorage.setItem("LoginTag", userEmail ? "Email" : "PhoneNo");
        const userResponse = await fetch(tenantUrl, {
          method: "GET",
          headers: {
            "content-type": "application/json",
          },
        });
        const resData = await userResponse.json();
        if (userResponse?.ok) {
          localStorage.setItem("tenantCount", resData?.length);
        } else {
          showToast(
            "error",
            "Couldn't load the dashboard. Please refresh the page.",
          );
        }
        localStorage.setItem("LoginTag", userEmail ? "Email" : "PhoneNo");
        localStorage.setItem("currentuser", JSON.stringify(userData));
      }
    }
  }, [
    domainUrl,
    userEmail,
    userPhoneNumber,
  ]);

  useEffect(() => {
    const sessionKey = JSON.stringify([domainUrl, tokenDetails || user_token]);
    if (bootstrapSession.current === sessionKey) return;
    bootstrapSession.current = sessionKey;
    const initApp = async () => {
      if (tokenDetails) {
        localStorage.clear();
        await getUserDetails();
        localStorage.setItem("token", tokenDetails);
        dispatch(setToken(tokenDetails));
      }
      if (!user_token && !tokenDetails) {
        localStorage.setItem("LoginTag", "Email");
        setRedirect("/auth/login");
        setAuthenticated(false);
        setLoading(false);
        dispatch(setVisible(false));
      } else {
        if (user_token || tokenDetails) {
          const currentUserString = tokenDetails
            ? currentUserDetails
            : JSON.parse(localStorage.getItem("currentuser"));
          let api_token = tokenDetails
            ? tokenDetails
            : localStorage.getItem("token");
          try {
            await updateCompanyDetails(
              api_token,
              currentUserString.id,
              domainUrl,
              currentUserString.type,
            );
            await updateCurrentUserDetails(currentUserString, api_token);
          } catch (error) {
            showToast("error", error.message);
            setRedirect("/auth/login");
            setAuthenticated(false);
            setLoading(false);
          }
        }
      }
    };
    initApp();
  }, [
    dispatch,
    domainUrl,
    getUserDetails,
    tokenDetails,
    updateCompanyDetails,
    updateCurrentUserDetails,
    user_token,
  ]);

  return (
    <ContactDrawerProvider>
      <BrowserRouter>
        <Switch>
          {authenticated ? (
            <Route
              path="/admin"
              render={(props) =>
                authenticated ? (
                  <AdminLayout {...props} />
                ) : (
                  <Redirect to="/auth/login" />
                )
              }
            />
          ) : (
            <Route
              path="/auth"
              render={(props) =>
                authenticated === false ? (
                  <AuthLayout {...props} />
                ) : (
                  <Redirect to="/admin/myzone/status" />
                )
              }
            />
          )}
          <Redirect to={redirect} />
        </Switch>
      </BrowserRouter>
      {/* <KnowlarityWidget2 /> */}

      <FrajunWidget />
      {/* Render only for users who have CRM product access */}
      {productAccess?.some((p) => p.product_name === "CRM") && (
        <IncomingCallNotification />
      )}
      <ToastContainer toastStyle={toastContainerStyle} />
      {loading ? <Loader info="Loading..." /> : null}
    </ContactDrawerProvider>
  );
}